import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory as CreateHistory } from 'history';
import { ThroughProvider } from 'react-through';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import router from './router';
import './App.scss';

const history = new CreateHistory({
	basename: '/',
});
// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'unique', {
	enumerable: false,
	configurable: false,
	writable: false,
	value() {
		const a = this.concat();
		for (let i = 0; i < a.length; ++i) {
			for (let j = i + 1; j < a.length; ++j) {
				if (a[i].id === a[j].id) a.splice(j--, 1);
			}
		}

		return a;
	},
});

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	msieversion() {
		const ua = window.navigator.userAgent;

		if (ua.indexOf('MSIE') > 0 || ua.indexOf('Trident') > 0) {
			return true;
		}

		return false;
	}

	render() {
		return this.msieversion() ? (
			<div className='container pt-5'>
				<div className='d-column-flex text-center'>
					<h1>Atenção</h1>

					<p>
						O sistema do Novo Focus não dá mais suporte para este navegador. <br />
						Copie o endereço abaixo e abra com o navegador Google Chrome.
					</p>
					<p>http://portalfornecedor.athiewohnrath.com.br</p>
				</div>
			</div>
		) : (
			<ThroughProvider>
				<Router basename='/' history={history}>
					<BreadcrumbsItem to='/'>Fornecedor</BreadcrumbsItem>
					{router()}
				</Router>
			</ThroughProvider>
		);
	}
}

export default App;
